export default __webpack_public_path__ + "static/media/ukflag.fddaa529.webp";